import { TFunction } from 'i18next';
import { IExpandableGridColumn } from '@components/core/expandable/grid/interfaces/grid-props.interface';
import { GridColumnMenuActiveFilter } from '@components/core/grid-filters';
import { useGridCells } from '@hooks/index';
import { formatDateUTC_DEPRECATED } from '@utils/convertor';

const { YesNoCell, MaxLengthCell, CustomizableCell } = useGridCells();

export const AUDIT_LOG_COLUMNS = (t: TFunction): IExpandableGridColumn[] => [
    {
        field: '_itemId',
        lockedByDefault: true,
        label: 'ID',
        minWidth: 160,
    },
    {
        label: 'Study',
        field: 'studyName',
        id: 'study-id',
        minWidth: 200,
    },
    {
        label: 'System',
        field: 'system',
        id: 'audit-system',
        minWidth: 180,
        cells: { data: YesNoCell },
        filterUi: GridColumnMenuActiveFilter,
    },
    {
        label: 'Name',
        field: 'description',
        id: 'audit-item-name',
        minWidth: 200,
        // 30vh should never overflow the body as long as the cell content is 40vh or less.
        // This should always be the case, since 200 * @ or emojis in a 200px width cell is less than 40vh.
        cells: { data: MaxLengthCell(200, '30vh') },
    },
    {
        label: 'Date/Time',
        field: 'created',
        id: 'audit-time',
        minWidth: 200,
        cells: {
            data: CustomizableCell((dataItem: any) =>
                formatDateUTC_DEPRECATED(dataItem.created, true, 'DD-MMM-YYYY HH:mm:ss UTC'),
            ),
        },
        filter: 'date',
    },
    {
        label: 'Action',
        field: '_translatedAction',
        id: 'audit-action',
        minWidth: 200,
    },
    {
        label: 'First Name',
        field: 'userFirstName',
        id: 'user-first-name',
        minWidth: 180,
    },
    {
        label: 'Last Name',
        field: 'userLastName',
        id: 'user-last-name',
        minWidth: 180,
    },
    {
        label: 'Email',
        field: 'userEmail',
        id: 'user-email',
        minWidth: 250,
    },
    {
        field: 'recordId',
        label: 'User ID',
        filter: 'numeric',
        minWidth: 170,
    },
    {
        label: 'Entity Type',
        field: '_entityType',
        id: 'item-type',
        minWidth: 300,
    },
    {
        label: t('ra:reasonForChange'),
        field: 'reason',
        id: 'audit-reason',
        minWidth: 250,
    },
    {
        label: 'IP Address',
        field: 'userIpAddress',
        id: 'user-ip-address',
        minWidth: 200,
        showByDefault: false,
    },
];
